import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CreateManageReleases from "./components/CreateManageReleases";
import Dashboard from "./components/Dashboard";
import DeploymentComponent from "./components/DeploymentPlan";
import ManageReleases from "./components/ManageReleases";
import Tracker from "./components/Tracker";

import AppsIcon from "@mui/icons-material/Apps";
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";

// Add import for ComingSoon
import ComingSoon from "./components/ComingSoon";

const drawerWidth = 250;

function Sidebar({ open, onClose }) {
  const location = useLocation();
  return (
    <Drawer
      variant="persistent"
      open={open}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          background: "#f5f6fa",
          borderRight: "1px solid #e0e0e0",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "fixed",
          top: 10,
          left: 0,
          zIndex: 1400,
        }}
        aria-label="close sidebar"
      >
        <CloseIcon />
      </IconButton>

      <Box sx={{ overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            py: 2,
          }}
        >
          <img
            src="/logo.jpeg"
            alt="Deployment Tracker Logo"
            style={{
              marginBottom: 8,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#3f51b5",
              letterSpacing: 1,
            }}
          >
            Deployment Tracker
          </Typography>
        </Box>
        <hr />
        <List>
          <ListItem
            button
            component={Link}
            to="/dashboard"
            selected={location.pathname === "/"}
          >
            <ListItemIcon>
              <AppsIcon
                color={
                  location.pathname === "/dashboard" ? "primary" : "inherit"
                }
              />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/releases"
            selected={location.pathname === "/releases"}
          >
            <ListItemIcon>
              <BarChartIcon
                color={
                  location.pathname === "/releases" ? "primary" : "inherit"
                }
              />
            </ListItemIcon>
            <ListItemText primary="Deployments Status" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/manage-releases"
            selected={location.pathname === "/manage-releases"}
          >
            <ListItemIcon>
              <BarChartIcon
                color={
                  location.pathname === "/manage-releases"
                    ? "primary"
                    : "inherit"
                }
              />
            </ListItemIcon>
            <ListItemText primary="Manage Deployments" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/other"
            selected={location.pathname === "/other"}
          >
            <ListItemIcon>
              <BarChartIcon
                color={location.pathname === "/other" ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText primary="Other Options" />
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
}

function App() {
  const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <Router>
      <Box
        sx={{ display: "flex", minHeight: "50vh" }}
        className={drawerOpen ? "sidebar-open" : "sidebar-closed"}
      >
        {!drawerOpen && (
          <IconButton
            onClick={() => setDrawerOpen(true)}
            sx={{
              position: "fixed",
              top: 10,
              left: 0,
              zIndex: 1400,
            }}
            aria-label="open sidebar"
          >
            <MenuIcon />
          </IconButton>
        )}
        {drawerOpen && (
          <Sidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        )}
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            ml: drawerOpen ? `0px` : "0px",
            transition: "margin-left 0.3s,width 0.3s",
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/releases" element={<ManageReleases />} />
              <Route
                path="/manage-releases"
                element={<CreateManageReleases />}
              />
              <Route
                path="/areas/:index/deployment/:releaseName/"
                element={<DeploymentComponent />}
              />
              <Route
                path="/areas/:index/tracker/:releaseName"
                element={<Tracker />}
              />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/other" element={<ComingSoon />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Box>
    </Router>
  );
}

export default App;
